import orderBy from 'lodash/orderBy';
import * as React from 'react';
import { SeatStyle, SeatStyleCulture } from '../../classes/seat';
import { Html } from '../../helpers/html-helpers';
import { formatString } from '../../helpers/string-format';



interface ILegendProps {
    seatStyles: Array<SeatStyle>;
    seatStyleCultures: Array<SeatStyleCulture>;
    legendTitle: string;
    legendModalText: string;
    legendTitleAltText: string;
    selectedSeats: boolean;
    legendFlyOut: boolean;
    updateLegendFlyout: (updateFlyout: boolean) => void;
    isMobile: boolean;
    renderModal: boolean;
}

interface ILegendState {
    firstTimeHidden: boolean; //used to keep track so we only close the legend once so if users want to use the legend on mobile, they can open it again
}

class LegendContent extends React.PureComponent<ILegendProps, ILegendState>{

    render() {
        const culturesWithDisplayName = this.props.seatStyleCultures.filter(culture => culture.displayName != null);

        const visibleStyles = orderBy(this.props.seatStyles.filter(style => { return culturesWithDisplayName.some(culture => culture.seatStyleId === style.id) }),
            (style) => {
                return culturesWithDisplayName.filter(cultur => cultur.seatStyleId == style.id)[0].legendOrder;
            });

        let legendFilters =
            orderBy(visibleStyles.filter(style => culturesWithDisplayName.filter(cultur => cultur.seatStyleId == style.id)[0].showOnCollapsedLegend),
                (style) => {
                    return culturesWithDisplayName.filter(cultur => cultur.seatStyleId == style.id)[0].legendOrder;
                }
            ).map(style => {
                return <div key={style.id} className="legend-default-icon" style={{ backgroundColor: style.svgDefaultFill }}></div>;
            });

        if (legendFilters.length > 3) {
            legendFilters = legendFilters.filter((value, index) => index < 3);
        }

        return (
            <div className="legend-wrapper">
                <button type="button" className="legend-wrapper-button" onClick={(evt) => { this.props.updateLegendFlyout(true) }}>
                    {/*todo make this more dynamic */}
                    <span className="visually-hidden">Open Legend</span>
                    <div className={this.props.renderModal ? "legend-default-modal" : "legend-default"}>
                        <div className={this.props.renderModal ? "legend-default-modal-dots" : "legend-default-dots"}>
                            {
                                legendFilters
                            }
                        </div>
                        <p role="presentation">{this.props.legendTitle}</p>
                    </div>
                </button>
                <div className="legend-content">
                    <ul className="legend-list">
                        {visibleStyles.map(style => {
                            return <li key={style.id} className="legend-list-item">
                                <svg width="30px" className="legend-list-item-icon" viewBox={style.seatStyleSvgPath != null && style.seatStyleSvgPath.length > 0
                                    ? style.svgViewBox : "0 0 30 30"} role="presentation">
                                    {style.seatStyleSvgPath != null && style.seatStyleSvgPath.length > 0 ?
                                        <path d={style.seatStyleSvgPath} fill={style.svgDefaultFill} stroke={style.svgStrokeColor} strokeWidth={style.svgStrokeWidth}></path>
                                        :
                                        <circle r="15" cx="15" cy="15" fill={style.svgDefaultFill} stroke={style.svgStrokeColor} strokeWidth={style.svgDefaultFill != style.svgStrokeColor ? style.svgStrokeWidth : "0"}></circle>
                                    }
                                </svg>
                                <span className="legend-list-item-name">{culturesWithDisplayName.filter(culture => culture.seatStyleId == style.id)[0].displayName}</span>
                            </li>
                        })}
                    </ul>
                </div>

                {this.props.renderModal ? Html.renderDiv(this.props.legendModalText, "legend-modal-text") : null}

            </div>
        );
    }
}

export default LegendContent;